import api, { IPaginationResponse } from 'api/axiosInstance';
import { AxiosRequestConfig } from 'axios';
import { getInvoiceItemsTotalInclVAT } from 'components/pages/Revenues/OtherRevenueForm/utils';
import { RecurringInvoice } from 'types/invoice.types';
const service = 'v2/revenues/recurrings';

export const createRecurringRevenue = (data: RecurringInvoice) => {
  return api.post(`${service}`, data);
};

export const updateRecurringRevenue = (id: string, data: RecurringInvoice) => {
  return api.put(`${service}/${id}`, data);
};

export const deleteRecurringRevenue = (id: string) => {
  return api.delete(`${service}/${id}`);
};

export const pauseRecurringRevenue = (id: string) => {
  return api.post(`${service}/${id}/pause`);
};

export const resumeRecurringRevenue = (id: string) => {
  return api.post(`${service}/${id}/resume`);
};

export const getRecurringRevenue = (id: string): Promise<RecurringInvoice> => {
  return api.get(`${service}/${id}`).then(({ data }) => data);
};

type GetRecurringRevenuesFilters = {
  clientId?: string;
};

export const getRecurringRevenues = (
  filters?: GetRecurringRevenuesFilters,
  config?: AxiosRequestConfig,
): Promise<{ data: RecurringInvoice[] } & IPaginationResponse> => {
  return api
    .get<any, { data: RecurringInvoice[] }>(`${service}`, {
      params: filters,
      ...config,
    })
    .then(({ data }) => {
      return {
        data: data.map((doc) => {
          return {
            ...doc,
            _amount: getInvoiceItemsTotalInclVAT(doc.revenueData.items),
          };
        }),
        paging: {
          page: 1,
          pagesCount: 1,
          pageCount: 1,
          perPage: data.length,
          totalCount: data.length,
        },
      };
    });
};
